import axios from "axios"

export default {
    async CreateOrUpdate(update,data){
        const response = await axios.post(update ? '/api/sectortype/update' : '/api/sectortype/create',data)
        return response
    },
    async Delete(id){
        const response = await axios.post(`/api/sectortype/delete/${id}`)
        return response
    },
    async Table(data){
        const response = await axios.post('/api/sectortype/table',data)
        return response
    },
    async List(){
        const response = await axios.get(`/api/sectortype/list`)
        return response
    }
}